import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Dialog, Grid, TextField } from '@mui/material';
import PopupTitle from '../common/popup_title';
import { boardWithMenuRenamed } from '../../services/smorg_board';
import {
  useGetSmorgBoardQuery,
  useUpdateSmorgBoardMutation,
} from '../../app/smorgAppSyncGraphQLApi';

const RecipeCollectionsRenameMenuModal = ({
  boardID,
  menuID,
  initialTitle,
  onDismiss,
}) => {
  const [menuTitle, setMenuTitle] = useState(initialTitle);

  const isValid = !!menuTitle;

  const { data: recipesBoard } = useGetSmorgBoardQuery(boardID, {
    skip: !boardID,
  });

  const [updateSmorgBoard] = useUpdateSmorgBoardMutation();

  const onRename = async () => {
    const newBoard = boardWithMenuRenamed(recipesBoard, menuID, menuTitle);
    await updateSmorgBoard(newBoard);
    onDismiss();
  };

  return (
    <Dialog
      open
      // size="md"
      PaperProps={{
        style: {
          width: '420px',
          height: '160px',
          padding: '10px',
        },
      }}
      onClose={onDismiss}>
      <Grid container>
        <Grid item xs={12}>
          <PopupTitle
            closeButtonEnabled
            onClickClose={onDismiss}
            titleText="Rename menu"
          />
        </Grid>
        <Grid item xs={12} style={{ padding: '5px' }}>
          <TextField
            value={menuTitle}
            onChange={(ev) => {
              setMenuTitle(ev.target.value);
            }}
            autoFocus
            margin="dense"
            label=""
            type="text"
            fullWidth
            size="small"
            variant="standard"
            placeholder="e.g. My board"
          />
        </Grid>
        <Grid item xs={12} style={{ padding: '5px' }}>
          <Button
            onClick={(ev) => {
              onRename();
              ev.stopPropagation();
            }}
            variant="contained"
            size="medium"
            disabled={!isValid}
            disableElevation>
            Rename
          </Button>
        </Grid>
      </Grid>
    </Dialog>
  );
};

RecipeCollectionsRenameMenuModal.propTypes = {
  boardID: PropTypes.string.isRequired,
  menuID: PropTypes.string.isRequired,
  initialTitle: PropTypes.string.isRequired,
  onDismiss: PropTypes.func.isRequired,
};

export default RecipeCollectionsRenameMenuModal;
